<template>
  <div class="admin-video-tags">
    <admin-view-header title="Tagi">
      <protected :with="Permission.CREATE_TAG">
        <button class="button is-success" @click="openNewTagModal">
          <icon name="fa-plus" />
          <span>Nowy tag</span>
        </button>
      </protected>
    </admin-view-header>
    <loader :state="actions.tags">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Nazwa</th>
            <th>Akcja</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tag in tags" :key="tag.id">
            <td>{{ tag.name }}</td>
            <td class="nowrap">
              <protected :with="Permission.UPDATE_TAG">
                <icon
                  name="fa-pen"
                  data-tooltip="Edytuj tag"
                  class="icon-control"
                  @click="openEditTagModal(tag)"
                />
              </protected>
              <protected :with="Permission.DELETE_TAG">
                <icon
                  name="fa-trash"
                  data-tooltip="Usuń tag"
                  class="icon-control is-danger"
                  @click="showRemovalConfirmation(tag)"
                />
              </protected>
            </td>
          </tr>
        </tbody>
      </table>

      <template #loading>
        <div
          class="spinner is-3by4 is-grey-lighter is-large is-thick is-centered"
        />
      </template>

      <template #error>
        <div class="grey-message">
          <icon name="fa-times-circle" />
          <p>Dane niedostępne z powodu braku połączenia z serwerem.</p>
        </div>
      </template>
    </loader>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { FETCH_TAGS, ADD_TAG, UPDATE_TAG, DELETE_TAG } from ":actions";

import { Icon } from "%helpers";

import AdminViewHeader from "%admin/components/global/AdminViewHeader";

import { VideoTagModal, YesNoCancelModal } from "%modals";

import { SuccessNotification } from "%notifications";

import { Protected, WithDispatcherProgress } from "%mixins";

export default {
  name: "admin-video-tags",

  components: {
    Icon,
    AdminViewHeader
  },

  mixins: [Protected, WithDispatcherProgress],

  computed: mapState({
    tags: state => state.videos.tags
  }),

  beforeMount() {
    this.dispatchWithProgress("tags", FETCH_TAGS);
  },

  methods: {
    openNewTagModal() {
      this.$emit("show-modal", {
        component: VideoTagModal,
        props: {
          onSubmit: ({ name }) => this.addTag(name)
        }
      });
    },

    addTag(name) {
      return this.$store
        .dispatch(ADD_TAG, { name })
        .then(() => this.successNotification("Tag został utworzony."));
    },

    successNotification(content) {
      this.$emit("push-notification", {
        component: SuccessNotification,
        props: { content }
      });
    },

    openEditTagModal(tag) {
      this.$emit("show-modal", {
        component: VideoTagModal,
        props: {
          tag,
          onSubmit: ({ name }) => this.updateTag(tag.id, { name })
        }
      });
    },

    updateTag(id, tag) {
      return this.$store
        .dispatch(UPDATE_TAG, { id, tag })
        .then(() => this.successNotification("Tag został zaktualizowany."));
    },

    showRemovalConfirmation({ id, name }) {
      this.$emit("show-modal", {
        component: YesNoCancelModal,
        props: {
          title: "Potwierdzenie usunięcia",
          content: `
            <p>Czy na pewno chcesz usunąć tag <code>${name}</code>?</p>
            <p><strong>Uwaga!</strong> Operacja automatycznie i nieodwracalnie odłącza usuwany tag od każdego filmu, 
            do którego został on przypięty, nie usuwając jednak samego filmu.</p>            
          `,
          proceed: {
            type: "is-danger",
            icon: "fa-trash",
            content: "Usuń",
            callback: () => this.removeTag(id)
          },
          cancel: {
            content: "Anuluj"
          }
        }
      });
    },

    removeTag(id) {
      return this.$store.dispatch(DELETE_TAG, { id });
    }
  }
};
</script>

<style></style>
